import { IDelete, IGet, IPost, IPut } from '../types/request'
import apiClient from "./apiClient";

const API_URL = process.env.API_URL || 'https://dev-api-neptune.eeven.fr'
const token: string = localStorage.getItem('token') || ''

const headers = {
    "Authorization": `Bearer ${token}`
}

export const get = ({url, options}: IGet): Promise<any> => {
    return apiClient.get(`${API_URL}/${url}`, {
        ...options,
        headers
    })
}

export const post = ({url, data, options}: IPost): Promise<any> => {
    return apiClient.post(`${API_URL}/${url}`, data, {
        ...options,
        headers
    })
}

export const mutlipart_post = ({url, data, options}: IPost): Promise<any> => {
    return apiClient.post(`${API_URL}/${url}`, data, {
        ...options,
        headers: {
            ...headers,
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const put = ({url, data, options}: IPut): Promise<any> => {
    return apiClient.put(`${API_URL}/${url}`, data, {
        ...options,
        headers
    })
}

export const patch = ({url, data, options}: IPut): Promise<any> => {
    return apiClient.patch(`${API_URL}/${url}`, data, {
        ...options,
        headers: {
            ...headers,
            'Content-Type': 'application/merge-patch+json'
        }
    })
}

export const destroy = ({url, options}: IDelete): Promise<any> => {
    return apiClient.delete(`${API_URL}/${url}`, {
        ...options,
        headers
    })
}